
import { Component, Vue, Watch } from "vue-property-decorator";
import {
  // PdaUsercodename,
  // DestinationOrgcodename,
  LineListcodename
} from "@/views/components";
import { log } from "util";
@Component({
  name: "Form1",
  components: { LineListcodename },
  props: {
    callbackdata: {
      type: Object,
      default: false
    }
  },
  watch: {
    callbackdata(newone, oldone) {
      console.log("Form1组件的旧数据：");
      console.log(oldone);
      console.log("Form1组件的新数据：");
      console.log(newone);
      this.inputModel = newone;
      // this.options_NextOrg = newone.options_NextOrg;
      this.options_NextOrg = newone.options_NextOrg.map(item => {
        return { value: `${item.ID}`, label: `${item.Name}` };
      });
      if (this.options_NextOrg.length>0) {
        this.inputModel.input_OrgName = this.options_NextOrg[0].label;
      }
    }
  }
})
export default class extends Vue {
  private inputModel: inputDataModel_Depart = {
    checked_NextOrgCode: false,
    input_ScanCode: "",
    input_CarSignNum: "",
    input_LineNo: "",
    input_LineName: "",
    input_NextOrgCode: "",
    input_OrgName: "",
    checked_OverTimeCar: false,
    options_NextOrg: []
  };
  mounted() {
    this.$emit("get-form1-value", this.inputModel);
  }
  @Watch("inputModel", { deep: true })
  onChildChanged(val: string) {
    this.$emit("get-form1-value", val);
  }
  private linelistdialogshow = false;
  public linelistcodenameFunc(linelistModel) {
    this.linelistdialogshow = false;
    if (linelistModel != null) {
      this.inputModel.input_LineNo = linelistModel.lineNo;
      this.inputModel.input_LineName = linelistModel.lineName;
    }
    obj_ScanForDepart.getNextOrg(
      linelistModel.lineNo,
      linelistModel.lineName,
      this.getNextOrgCallback
    );
  }
  public options_NextOrg = [];
  //下一网点界面更新判定
  private getNextOrgCallback(datas) {
    //var routeNextOrgCode = obj_ScanForGetOn.getMode();
    this.inputModel.input_NextOrgCode = datas.nextOrgCode;
    var jsonobj = JSON.parse(datas.result);
    if (jsonobj.data.busiDataArray != null) {
      this.options_NextOrg = [];
      jsonobj.data.busiDataArray.forEach(element => {
        this.options_NextOrg.push({
          label: element.endOrgName,
          value: element.endOrgCode
        });
      });
      this.inputModel.input_OrgName = this.options_NextOrg[0].label;
    }

    // if (routeNextOrgCode == "1") {
    //   this.inputModel.input_NextOrg = "";
    //   this.inputModel.input_NextOrgNow = "";
    // }
  }
  public findlinelistcodename() {
    this.linelistdialogshow = true;
  }
  private clearlinecodename() {

    this.inputModel.input_LineNo = "";
    this.inputModel.input_LineName = "";
  }
  //下一网点选择
  private chooseNextOrgCode(item): void {
    this.inputModel.input_NextOrgCode = item.value;
  }
  //显示信息栏
  public messageboxShow(type, msg): void {
    // info
    // warning
    // success
    // error
    this.$message({
      message: msg,
      type: type
    });
  }

  public selectElementContents(el) {
    //失去焦点，获取焦点
    el.blur();
    el.focus();
  }
  //表格选中当前行
  public setCurrent(row) {
    // this.$refs.singleTable.setCurrentRow(row);
    this.$refs.singleTable[0].setCurrentRow();
  }
}
